import { baseUnit } from './spacing';

export const padding = {
  small: baseUnit * 2, // 8px
  medium: baseUnit * 4, // 16px
  large: baseUnit * 6, // 24px
  xLarge: baseUnit * 8, // 32px
};
